<template>
  <div class="main-container flex flex-center">
    <div class="main-box">
      <!--头部导航-->
      <div class="box-header flex flex-center">
        <div class="box-header-left flex flex-center"></div>
        <div class="box-header-right">
          <el-button
            type="primary"
            icon="el-icon-search"
            class="active-icon"
            @click="dialogTableVisible = true"
          ></el-button>
          <el-button type="primary" icon="el-icon-delete" class="active-icon"
            >删除</el-button
          >
        </div>
      </div>
      <!--内容-->
      <div class="box-content">
        <div class="box-item box-half box-active">
          <div class="box-item-img">
            <img src="../../assets/img/头像@2x.png" />
          </div>
          <div class="box-item-text">
            <div>用户名：张三</div>
            <div>公司：盛世科技股份有限公司</div>
            <div>地址：深圳市南山区</div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/位图@2x.png" />
          </div>
          <div class="box-item-text">
            <div>用户名：张三</div>
            <div>公司：盛世科技股份有限公司</div>
            <div>地址：深圳市南山区</div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/位图@2x.png" />
          </div>
          <div class="box-item-text">
            <div>用户名：张三</div>
            <div>公司：盛世科技股份有限公司</div>
            <div>地址：深圳市南山区</div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/位图@2x.png" />
          </div>
          <div class="box-item-text">
            <div>用户名：张三</div>
            <div>公司：盛世科技股份有限公司</div>
            <div>地址：深圳市南山区</div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/位图@2x.png" />
          </div>
          <div class="box-item-text">
            <div>用户名：张三</div>
            <div>公司：盛世科技股份有限公司</div>
            <div>地址：深圳市南山区</div>
          </div>
        </div>
      </div>
    </div>
    <div class="main-box border-1px-all">
      <section>
        <div class="flex flex-between">
          <div class="title-bc">用户详情</div>
        </div>
        <div class="flex flex-between input-line">
          <div class="flex input-wrap has-title" style="width: 45%">
            <span class="cus-input-title">用户名</span>
            <el-input placeholder="" type="text" v-model="username"> </el-input>
          </div>
          <div class="flex input-wrap has-title" style="width: 45%">
            <span class="cus-input-title">手机</span>
            <el-input placeholder="" type="text" v-model="phone"> </el-input>
          </div>
        </div>
        <div class="flex flex-between input-line">
          <div class="flex input-wrap has-title" style="width: 45%">
            <span class="cus-input-title">邮箱</span>
            <el-input placeholder="" type="text" v-model="email"> </el-input>
          </div>
          <div class="flex input-wrap has-title" style="width: 45%">
            <span class="cus-input-title">日期</span>
            <el-input placeholder="" type="text" v-model="date"> </el-input>
          </div>
        </div>
        <div class="flex flex-between input-line">
          <div class="flex input-wrap has-title" style="width: 100%">
            <span class="cus-input-title">公司</span>
            <el-input placeholder="" type="text" v-model="company"> </el-input>
          </div>
        </div>
        <div class="flex flex-between input-line">
          <div class="flex input-wrap has-title" style="width: 100%">
            <span class="cus-input-title">地址</span>
            <el-input placeholder="" type="text" v-model="address"> </el-input>
          </div>
        </div>
      </section>

      <section>
        <div
          class="flex flex-between"
          style="margin-top: 30px; margin-bottom: 10px"
        >
          <div class="title-bc">{{ $t("m.commentDetail.remark") }}</div>
        </div>
        <el-input placeholder="" type="textarea" v-model="remarks"> </el-input>
      </section>
    </div>
    <!--------搜索弹框---------->
    <el-dialog
      title="搜索"
      :visible.sync="dialogTableVisible"
      width="500px"
      :show-close="false"
    >
      <div>
        <div class="flex flex-center flex-between" style="margin-bottom:10px;">
          <span class="search-dialog-title">按序列号</span>
          <el-input placeholder="请输入"> </el-input>
        </div>
        <div class="flex flex-center flex-between" style="margin-bottom:10px;">
          <span class="search-dialog-title">按用户名</span>
          <el-input placeholder="请输入"> </el-input>
        </div>
        <div class="flex flex-center flex-between" style="margin-bottom:10px;">
          <span class="search-dialog-title">按手机号</span>
          <el-input placeholder="请输入"> </el-input>
        </div>
        <div class="flex flex-center flex-between" style="margin-bottom:10px;">
          <span class="search-dialog-title">按地址</span>
          <el-input placeholder="请输入"> </el-input>
        </div>
      </div>
      <div slot="footer" class="flex flex-center">
        <div @click="dialogTableVisible = false" class="dialog-footer-btn">
          {{ $t("m.chart.table.cancel") }}
        </div>
        <div
          type="primary"
          @click="dialogTableVisible = false"
          class="dialog-footer-btn"
        >
          {{ $t("m.chart.table.confirm") }}
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "equipment-list",
  data() {
    return {
      username: "",
      date: "",
      phone: "",
      email: "",
      company: "",
      address: "",
      remarks: "",
      selectValue: "",
      dialogTableVisible: false,
    };
  },
  methods: {},
};
</script>

<style scoped>
.el-textarea__inner {
  height: 250px;
}
.box-item .box-item-img img {
  width: 54px;
}
</style>
